import React from 'react';
import PropTypes from 'prop-types';

const HeaderWrapper = ({ children }) => {
  return <header>{children}</header>;
};

HeaderWrapper.propTypes = {
  children: PropTypes.node
};

export default HeaderWrapper;
